export default __webpack_public_path__ + "static/media/Lem-Lem.ce6b12af.jpg";